import { OF } from '../../util/network';
import { JBaseApi } from '../base';

import { ApiWrapper, Format, FormatList } from '../../types/utils';
import {
    CalendarCombinedEventsList,
    CalendarEventListAbstractType,
    CalendarEventLittleAbstractType,
    CalendarOldEvent,
    EventStatusFilter,
} from '../../types/calendar';
import { CalendarEventWithExtensions } from '../../types/withExtensions';
import { combineFormat } from '../../util/object';

export class JCalendarApi extends JBaseApi {
    /**
     * @deprecated Use `getEventsV2` instead.
     */
    public getEvents(params: {
        end?: string;
        start?: string;
        mode?: 'spot' | 'user';
        idSpot?: number;
        idArticle?: number;
    }): Promise<ApiWrapper<CalendarOldEvent[]>> {
        return this.network.post({ o: 'calendar', f: 'getEvents', ...params } as OF);
    }

    public listEvents<T extends CalendarEventLittleAbstractType = CalendarEventListAbstractType>(
        params: { dateStart: string; dateEnd: string; statuses?: EventStatusFilter[]; types?: string[] },
        options?: {
            signal?: AbortSignal;
            format?: FormatList;
        },
    ): Promise<ApiWrapper<CalendarEventWithExtensions<T, ['socialEventRecord']>[]>> {
        return this.network.post(
            {
                o: 'calendar',
                f: 'listEvents',
                ...params,
                format: combineFormat(options?.format ?? 'raw-list', ['socialEventRecord']),
            } as OF,
            options?.signal,
        );
    }

    public getLastEvents(params: {
        uriContext?: string;
        page?: number;
        limit?: number;
        format?: Format;
    }): Promise<ApiWrapper<CalendarCombinedEventsList[]>> {
        return this.network.post({ o: 'calendar', f: 'getLastEvents', ...params } as OF);
    }

    public reviveSubmit(params: {
        idArticle: number;
        list: 'all' | 'available' | 'presence' | 'onSpot' | 'visio' | 'unavailable' | 'waiting' | 'unit' | 'refused';
        text: string;
        userURI?: string;
    }): Promise<ApiWrapper<boolean>> {
        return this.network.postCSRF({ o: 'calendar', f: 'reviveSubmit', ...params } as OF);
    }
}
